/**
 * Hotspot image - Alpine component for the "hyperdigital/hotspot" content element.
 *
 * One panel is open at a time. Markers are <button>s with aria-expanded / aria-controls, the
 * panel is a labelled group. Escape and clicks outside close it (bound in the template); closing
 * via the panel's own close button returns focus to the marker so keyboard users do not lose their
 * place. Tabbing past the last focusable element of the panel closes it as well, so the panel never
 * traps focus and the page order stays natural.
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('hotspotImage', () => ({
        open: null,

        isOpen(index) {
            return this.open === index;
        },

        toggle(index) {
            this.open = this.open === index ? null : index;
        },

        /**
         * @param {boolean} returnFocus  move focus back to the marker that owns the open panel
         */
        close(returnFocus = false) {
            if (this.open === null) {
                return;
            }
            const marker = this.marker(this.open);
            this.open = null;
            if (returnFocus && marker) {
                marker.focus();
            }
        },

        /** Used by the optional list below the image: jump to and open the marker on the image. */
        focusMarker(index) {
            const marker = this.marker(index);
            if (!marker) {
                return;
            }
            this.open = index;
            marker.scrollIntoView({ block: 'center', behavior: this.reducedMotion() ? 'auto' : 'smooth' });
            marker.focus({ preventScroll: true });
        },

        /** Tab on the last focusable element of the panel closes it - focus continues naturally. */
        trapEnd(event, index) {
            if (event.shiftKey || this.open !== index) {
                return;
            }
            const panel = event.currentTarget;
            const focusable = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
            if (focusable.length && event.target === focusable[focusable.length - 1]) {
                this.open = null;
            }
        },

        marker(index) {
            return this.$root.querySelector('.hotspot-marker[data-index="' + index + '"]');
        },

        reducedMotion() {
            return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        },
    }));
});
